// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .schedForm {
  flex: 3 1;
  background-color: #f6f3f3;
  color: #000;
  padding: 20px 0px;
}
.theme-light .schedForm .mapContainer {
  margin: 20px 0;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
}
.theme-light .schedForm .selectedLocation {
  margin-bottom: 20px;
}
.theme-light .schedForm .selectedLocation p {
  font-weight: bold;
}
.theme-light .schedForm .formGroup {
  margin: 5px;
}
.theme-light .schedForm .formGroup label {
  display: block;
  font-weight: 500;
  margin-bottom: 5px;
}
.theme-light .schedForm #metadata {
  min-width: 400px;
  min-height: 300px;
  padding: 10px;
  border: 1px solid;
  border-radius: 4px;
  background-color: white;
  color: #000;
}
.theme-light .schedForm .submitButton {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: blue;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
}
.theme-light .schedForm .resetButton {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: red;
  color: white;
  cursor: pointer;
  margin-right: 10px;
}
.theme-dark .schedForm {
  flex: 3 1;
  background-color: #333;
  color: #fffef9;
  padding: 20px 0px;
}
.theme-dark .schedForm .mapContainer {
  margin: 20px 0;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
}
.theme-dark .schedForm .selectedLocation {
  margin-bottom: 20px;
}
.theme-dark .schedForm .selectedLocation p {
  font-weight: bold;
}
.theme-dark .schedForm .formGroup {
  margin: 5px;
}
.theme-dark .schedForm .formGroup label {
  display: block;
  font-weight: 500;
  margin-bottom: 5px;
}
.theme-dark .schedForm #metadata {
  min-width: 400px;
  min-height: 300px;
  padding: 10px;
  border: 1px solid;
  border-radius: 4px;
  background-color: #222;
  color: #fffef9;
}
.theme-dark .schedForm .submitButton {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: blue;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
}
.theme-dark .schedForm .resetButton {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: red;
  color: white;
  cursor: pointer;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/schedules/schedForm.scss"],"names":[],"mappings":"AAqBI;ECjBA,SAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;AAFJ;AAKI;EACE,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAHN;AAMI;EACE,mBAAA;AAJN;AAKM;EACE,iBAAA;AAHR;AAOI;EACE,WAAA;AALN;AAOM;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AALR;AAWI;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;AATN;AAaI;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AAXN;AAkBI;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAhBN;AD/BI;ECjBA,SAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;AAmDJ;AAhDI;EACE,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAkDN;AA/CI;EACE,mBAAA;AAiDN;AAhDM;EACE,iBAAA;AAkDR;AA9CI;EACE,WAAA;AAgDN;AA9CM;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AAgDR;AA1CI;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AA4CN;AAxCI;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AA0CN;AAnCI;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAqCN","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.schedForm {\n  @include themify($themes) {\n    flex: 3;\n    background-color: themed(\"bgSoft\");\n    color: themed(\"textColor\");\n    padding: 20px 0px;\n\n\n    .mapContainer {\n      margin: 20px 0;\n      border: 1px solid #ccc;\n      border-radius: 8px;\n      overflow: hidden;\n    }\n  \n    .selectedLocation {\n      margin-bottom: 20px;\n      p {\n        font-weight: bold;\n      }\n    }\n    \n    .formGroup {\n      margin: 5px;\n    \n      label {\n        display: block;\n        font-weight: 500;\n        margin-bottom: 5px;\n      }\n\n      \n    }\n\n    #metadata { // textarea\n      min-width: 400px;\n      min-height: 300px;\n      padding: 10px;\n      border: 1px solid themed(\"borderColor\");\n      border-radius: 4px;\n      background-color: themed(\"bg\");\n      color: themed(\"textColor\");\n      // resize: ;\n    }\n\n    .submitButton {\n      padding: 10px 20px;\n      border: none;\n      border-radius: 4px;\n      background-color: blue;\n      color: white;\n      cursor: pointer;\n      transition: background-color 0.3s;\n\n      &:hover {\n        background-color: themed(\"primary\");\n      }\n    }\n\n    .resetButton {\n      padding: 10px 20px;\n      border: none;\n      border-radius: 4px;\n      background-color: red;\n      color: white;\n      cursor: pointer;\n      margin-right: 10px;\n\n      &:hover {\n        background-color: themed(\"danger\");\n      }\n    }\n\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
